import { state } from './state';
import { renderer, scene, camera, wrap } from './scene';

// ─── Export ────────────────────────────────────────────────────────
export function exportFrame(scale = 1): void {
  const w = wrap.clientWidth,
    h = wrap.clientHeight || 500;
  const wasAuto = state.autoRot;
  state.autoRot = false;
  if (scale !== 1) {
    renderer.setPixelRatio(window.devicePixelRatio * scale);
    renderer.setSize(w, h, false);
  }
  renderer.render(scene, camera);
  const dataURL = renderer.domElement.toDataURL('image/png');
  if (scale !== 1) {
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }
  state.autoRot = wasAuto;
  const a = document.createElement('a');
  a.href = dataURL;
  a.download = `book-mockup-${scale}x-${Date.now()}.png`;
  a.click();
}
